import _toConsumableArray from "/workspace/wsg-frontend/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/workspace/wsg-frontend/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import escapeStringRegexp from 'escape-string-regexp';
import transliterate from '@sindresorhus/transliterate';
import builtinOverridableReplacements from './overridable-replacements.js';

var decamelize = function decamelize(string) {
  return string // Separate capitalized words.
  .replace(/([A-Z]{2,})(\d+)/g, '$1 $2').replace(/([a-z\d]+)([A-Z]{2,})/g, '$1 $2').replace(/([a-z\d])([A-Z])/g, '$1 $2') // `[a-rt-z]` matches all lowercase characters except `s`.
  // This avoids matching plural acronyms like `APIs`.
  .replace(/([A-Z]+)([A-Z][a-rt-z\d]+)/g, '$1 $2');
};

var removeMootSeparators = function removeMootSeparators(string, separator) {
  var escapedSeparator = escapeStringRegexp(separator);
  return string.replace(new RegExp("".concat(escapedSeparator, "{2,}"), 'g'), separator).replace(new RegExp("^".concat(escapedSeparator, "|").concat(escapedSeparator, "$"), 'g'), '');
};

var buildPatternSlug = function buildPatternSlug(options) {
  var negationSetPattern = 'a-z\\d';
  negationSetPattern += options.lowercase ? '' : 'A-Z';

  if (options.preserveCharacters.length > 0) {
    var _iterator = _createForOfIteratorHelper(options.preserveCharacters),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var character = _step.value;

        if (character === options.separator) {
          throw new Error("The separator character `".concat(options.separator, "` cannot be included in preserved characters: ").concat(options.preserveCharacters));
        }

        negationSetPattern += escapeStringRegexp(character);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return new RegExp("[^".concat(negationSetPattern, "]+"), 'g');
};

export default function slugify(string, options) {
  if (typeof string !== 'string') {
    throw new TypeError("Expected a string, got `".concat(typeof string, "`"));
  }

  options = _objectSpread({
    separator: '-',
    lowercase: true,
    decamelize: true,
    customReplacements: [],
    preserveLeadingUnderscore: false,
    preserveTrailingDash: false,
    preserveCharacters: []
  }, options);
  var shouldPrependUnderscore = options.preserveLeadingUnderscore && string.startsWith('_');
  var shouldAppendDash = options.preserveTrailingDash && string.endsWith('-');
  var customReplacements = new Map([].concat(_toConsumableArray(builtinOverridableReplacements), _toConsumableArray(options.customReplacements)));
  string = transliterate(string, {
    customReplacements: customReplacements
  });

  if (options.decamelize) {
    string = decamelize(string);
  }

  var patternSlug = buildPatternSlug(options);

  if (options.lowercase) {
    string = string.toLowerCase();
  } // Detect contractions/possessives by looking for any word followed by a `'t`
  // or `'s` in isolation and then remove it.


  string = string.replace(/([a-zA-Z\d]+)'([ts])(\s|$)/g, '$1$2$3');
  string = string.replace(patternSlug, options.separator);
  string = string.replace(/\\/g, '');

  if (options.separator) {
    string = removeMootSeparators(string, options.separator);
  }

  if (shouldPrependUnderscore) {
    string = "_".concat(string);
  }

  if (shouldAppendDash) {
    string = "".concat(string, "-");
  }

  return string;
}
export function slugifyWithCounter() {
  var occurrences = new Map();

  var countable = function countable(string, options) {
    string = slugify(string, options);

    if (!string) {
      return '';
    }

    var stringLower = string.toLowerCase();
    var numberless = occurrences.get(stringLower.replace(/(?:-\d+?)+?$/, '')) || 0;
    var counter = occurrences.get(stringLower);
    occurrences.set(stringLower, typeof counter === 'number' ? counter + 1 : 1);
    var newCounter = occurrences.get(stringLower) || 2;

    if (newCounter >= 2 || numberless > 2) {
      string = "".concat(string, "-").concat(newCounter);
    }

    return string;
  };

  countable.reset = function () {
    occurrences.clear();
  };

  return countable;
}